// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getServicesProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetServiceProfessionalApi = createAsyncThunk(
  "hitGetServiceProfessionalApi",
  async (search = "") => {
    try {
      const token = localStorage.getItem("professionalToken");
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          ...(token ? { Authorization: token } : {}),
        },
        params: {
          search,
        },
      };
      const url = ApiBaseUrl + getServicesProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetServiceProfessionalSlice = createSlice({
  name: "getServiceProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetServiceData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetServiceProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetServiceProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetServiceProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetServiceData } = GetServiceProfessionalSlice.actions;
export default GetServiceProfessionalSlice.reducer;
